import { usePermissions } from '@/shared/permissions';

import { INVENTORY_PERMISSIONS } from '../model/permissions';

export interface InventoryPermissions {
  /** Read stock list, per-product stock, movement ledger, alerts, and policy GET. */
  canView: boolean;
  /** Record receipts/adjustments/transfers and upsert stock policy. */
  canManage: boolean;
}

/** Resolves the two inventory permission flags from the session permissions. */
export function useInventoryPermissions(): InventoryPermissions {
  const { hasPermission } = usePermissions();
  return {
    canView: hasPermission(INVENTORY_PERMISSIONS.view),
    canManage: hasPermission(INVENTORY_PERMISSIONS.manage),
  };
}
